<app-company-registration *ngIf="isCompanyDetailsSubmitted" [Data]="pay_Load"
    (CompanyRegistrationEvent)="CompanyRegistrationEvent($event)" [isRead]="isRead"></app-company-registration>